import React, { useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";

const App = () => {
  // State to track the active tab
  const [activeTab, setActiveTab] = useState("home");

  return (
    <div className=''>
      <Navbar setActiveTab={setActiveTab} activeTab={activeTab} />

      {/* Conditionally render content based on the active tab */}
      {/* <div className=''>{activeTab === "home" ? <Home /> : <About />}</div> */}
      <div className=''>{activeTab === "home" && <Home />}</div>
      <Footer />
    </div>
  );
};

export default App;
